import { render, staticRenderFns } from "./PNTest.vue?vue&type=template&id=2f976e0e&scoped=true&"
import script from "./PNTest.vue?vue&type=script&lang=js&"
export * from "./PNTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f976e0e",
  null
  
)

export default component.exports